import { Draggable } from "@hello-pangea/dnd";
import { DragHandleIcon, IconButton, IncidentCard } from "@all-manager/design-system-v2";
import type { IncidentDatabase } from "../../../../../types";
import { useIncidentKanbanCard } from "./useIncidentKanbanCard";

type Props = {
  incident: IncidentDatabase;
  index: number;
  onStatusChange?: (incidentId: string, newStatus: 'in_progress' | 'resolved') => void;
  onEdit?: (incident: IncidentDatabase) => void;
};

export default function IncidentKanbanCard(props: Props) {
  const { documents, handleToggleStatus, handleEdit } = useIncidentKanbanCard(props);

  return (
    // The handle is a button: allow it to start the drag.
    <Draggable
      draggableId={props.incident.id}
      index={props.index}
      isDragDisabled={!props.onStatusChange}
      disableInteractiveElementBlocking
    >
      {(provided) => (
        <div ref={provided.innerRef} {...provided.draggableProps}>
          <IncidentCard
            incident={props.incident}
            documents={documents}
            dragHandle={props.onStatusChange ? (
              <IconButton
                {...provided.dragHandleProps}
                size="small"
                tooltip="Déplacer l'incident vers l'autre colonne"
              >
                <DragHandleIcon fontSize="small" />
              </IconButton>
            ) : undefined}
            onToggleStatus={props.onStatusChange ? handleToggleStatus : undefined}
            onEdit={props.onEdit ? handleEdit : undefined}
          />
        </div>
      )}
    </Draggable>
  );
}
